import { Box, useTheme } from "@mui/material";
import { useState } from "react";
import { STEPS_REGISTER } from "../utils/util";
import { getPackageInfo, isVumaPackage } from "../utils/commons";

export function useSteps(steps) {
    const [step, setStep] = useState(0);
    const [virtualStep, setVirtualStep] = useState(null);
    // virtualStep: null | "PackageSelect"

    const nextStep = () => {
        setStep((s) => Math.min(Math.floor(s) + 1, steps.length - 1));
        setVirtualStep(null);
    };

    const prevStep = () => {
        setStep((s) => Math.max(Math.floor(s) - 1, 0));
        setVirtualStep(null);
    };

    const goToStep = (index) => {
        const packageInfo = getPackageInfo();
        if (index >= 0 && index < steps.length) {
            if (packageInfo && index == 3) {
                if (isVumaPackage(packageInfo.product_type)) {
                    setStep(3)
                } else {
                    setVirtualStep(STEPS_REGISTER.billing_date)
                }
            } else {
                setStep(index);
                setVirtualStep(null);
            }
        }
    };

    const goToStepByName = (name) => {
        if (name === STEPS_REGISTER.package_confirmation) {
            setStep(1.5);
            setVirtualStep(STEPS_REGISTER.package_confirmation);
            return;
        }
        if (name === STEPS_REGISTER.rica_verification) {
            setStep(2.5);
            setVirtualStep(STEPS_REGISTER.rica_verification);
            return;
        }
        if (name === STEPS_REGISTER.place_order) {
            setStep(3.5);
            setVirtualStep(STEPS_REGISTER.place_order);
            return;
        }
        if (name === STEPS_REGISTER.billing_date) {
            setStep(3.5);
            setVirtualStep(STEPS_REGISTER.billing_date);
            return;
        }
        const index = steps.findIndex((s) => s === name);
        if (index !== -1) {
            setStep(index);
            setVirtualStep(null);
        }
    };

    return {
        step,
        virtualStep,
        nextStep,
        prevStep,
        goToStep,
        goToStepByName,
    };
}

export default function SimpleSteps({
    steps,
    step,
    nextStep,
    prevStep,
    goToStep,
}) {
    const { palette } = useTheme();

    const segment = 100 / (steps.length - 1);
    const progressPercent = step === 0 ? segment / 2 : step * segment;

    return (
        <Box
            sx={{
                px: { xs: 2, sm: 3, md: 5 },
                py: 3,
                width: "100%",
                maxWidth: 900,
                mx: "auto",
            }}
        >
            {/* ===== Progress bar ===== */}
            <Box sx={{ position: "relative", mb: 3 }}>
                <Box
                    sx={{
                        height: { xs: 10, sm: 14, md: 18 },
                        backgroundColor: palette.common.white,
                        borderRadius: 999,
                        overflow: "hidden",
                    }}
                >
                    <Box
                        sx={{
                            height: "100%",
                            width: `${progressPercent}%`,
                            backgroundColor: palette.primary.main,
                            transition: "width 0.3s ease",
                            borderRadius: 999,
                        }}
                    />
                </Box>

                {/* ===== Markers ===== */}
                {steps.map((_, index) => {
                    if (index === 0 || index === steps.length - 1) return null;

                    return (
                        <Box
                            key={index}
                            sx={{
                                position: "absolute",
                                top: { xs: -6, sm: -10 },
                                left: `${(index / (steps.length - 1)) * 100}%`,
                                transform: "translateX(-50%)",
                                width: 2,
                                height: { xs: 20, sm: 28, md: 36 },
                                backgroundColor: palette.primary.main,
                            }}
                        />
                    );
                })}
            </Box>

            <Box
                sx={{
                    position: "relative",
                    height: { xs: 28, sm: 36 },
                    mt: 1,
                }}
            >
                {steps.map((label, index) => {
                    const leftPercent = (index / (steps.length - 1)) * 100;

                    return (
                        <Box
                            key={label}
                            // onClick={() => index <= step && goToStep(index)}
                            sx={{
                                position: "absolute",
                                left: `${leftPercent}%`,
                                transform: "translateX(-50%)",
                                cursor: index <= step ? "pointer" : "not-allowed",
                                color:
                                    index <= step
                                        ? palette.primary.main
                                        : palette.grey[400],
                                fontSize: { xs: 12, sm: 14, md: 18 },
                                fontWeight: 700,
                                whiteSpace: "nowrap",
                                userSelect: "none",
                                textAlign: "center",
                            }}
                        >
                            {label}
                        </Box>
                    );
                })}
            </Box>

        </Box>
    );
}
